/*global Handsontable:true*/
import Handsontable from 'handsontable-pro/dist/handsontable.full.js'
import 'handsontable-pro/dist/handsontable.full.css'

import React from 'react'

window.Handsontable = Handsontable

export default React.createClass({
  getInitialState() {
    return {
      data:this.props.data,
      id:'handsontable'+Date.now(),
      editing:false
    }
  },

  componentDidMount() {
    let container = document.getElementById(this.state.id)
    this.columnSorting = this.props.columnSorting
    let {noSorting} = this.props
    this.table = new Handsontable(container,
    { ...this.props,
      data: [],
      height: window.innerHeight-48,
      columnSorting:this.props.columnSorting || true,
      rowHeaders: true,
      manualColumnResize: true,
      manualRowResize: true,
      manualColumnFreeze: true,
      sortIndicator:!noSorting &&true,
      copyPaste: true,
      contextMenu: !noSorting && ['redo', 'undo'],
      dropdownMenu: !noSorting && ['filter_by_condition','filter_by_value','filter_action_bar'],
      filters:!noSorting && true,
      afterColumnSort: (column,sortOrder) =>{
        this.columnSorting = {column,sortOrder}
        console.log('afterColumnSort',this.columnSorting)
      },
      afterFilter:(a,b,c)=>{
        // console.log('afterFilter',a)
        // let data = this.table.getData()
        // console.log('data',data)
      },
      afterChange: (change, source) => {
        if(change && source!=='external') {
          // console.log('afterChange',change)
          change.map((c)=>{
            let [row, _prop, oldVal, newVal] = c
            if(oldVal !== newVal) {
              let id = this.table.getDataAtCell(row,0)
              let {data} = this.state

              data = data[0].id ? data.filter(d=>(d.id===id))[0] : data[row]

              this.props.afterChange(data,row)
              this.table.render()
              if(!this.state.editing && !this.props.autoUpdate)
                this.setState({editing:true})
            }
          })
        }
      },
    })
    if(this.props.data){
      this.table.loadData(this.props.data)
    }
    // this.filters = this.table.getPlugin('Filters')
    // console.log('filters',this.filters)
  },

  insertRow(row){
    this.table.alter('insert_row', row);
  },
  removeRow(row){
    this.table.alter('remove_row', row);
  },
  setDataAtRowProp(row, prop, value){
    console.log('setDataAtRowProp',row, prop, value)
    this.table.setDataAtRowProp(row, prop, value)
  },

  componentWillReceiveProps(nextProps){
    let data = nextProps.data || []
    if(!this.state.editing && data !== this.state.data) {
      if(this.columnSorting)
        this.table.updateSettings({columnSorting: this.columnSorting})
      this.table.loadData(data)
      this.setState({data})
    }
  },

  render() {
    return (
      <div {...this.props} id={this.state.id}/>
      )
  }
})




/** WEBPACK FOOTER **
 ** ./src/app/components/HandsonTable.js
 **/